import template from './product-suggestion.html';
import controller from './product-suggestion.controller';

let productSuggestionComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default productSuggestionComponent;


// WEBPACK FOOTER //
// ./src/app/common/product-suggestion/product-suggestion.component.js